// extracted by mini-css-extract-plugin
export default {"wrapper":"MessagesHeader_wrapper__u4gy-","title":"MessagesHeader_title__gDzwj","rightBlock":"MessagesHeader_rightBlock__uM+cZ"};